<template>
  <span class="badge-invoice-request">
    {{ $t('common.ui.invoiceRequest') }}
  </span>
</template>

<script>
export default {
  name: 'badge-invoice-request',
  props: {
    isCompany: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

.badge-invoice-request {
  background: lighten($color-warning, 45%);
  border: 1px solid $color-warning;
  border-radius: $border-radius-small;
  color: $color-warning;
  display: inline-block;
  font-size: 1.1rem;
  font-weight: 600;
  letter-spacing: .025rem;
  line-height: 1.6rem;
  padding: .125rem .5rem;
  text-align: center;
  text-transform: uppercase;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/common/BadgeInvoiceRequest.vue